export const mainBlue = '#699bbd;'
export const mainGray = '#686868;'
export const backgroundGray = '#fafafa';
export const highlightGray = '#ebebeb';
export const lineGray = '#ebebeb';
export const blueButtonText = '#fff';
export const hoverRed = '#e5a3a3';